var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search {\n  -ms-flex-item-align: center;\n      -ms-grid-row-align: center;\n      align-self: center;\n  border: none;\n  border-bottom: 1px solid #333;\n  margin-right: 10px;\n  background: url(" + escape(require("../../../assets/img/search.png")) + ") right center no-repeat;\n}\n.search:focus {\n  outline: none;\n}\n.search[placeholder] {\n  padding: 12px;\n  color: #666;\n  font-size: 14px;\n}\n.user-data {\n  width: 100%;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid #666666;\n  padding: 12px 0;\n  color: #666;\n  font-size: 14px;\n}\n.user-data:focus {\n  outline: none;\n}\n.user-data[placeholder] {\n  padding: 12px;\n  color: #666;\n  font-size: 14px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/debounce/debounce.component.less
// module id = ../../../../../src/app/shared/debounce/debounce.component.less
// module chunks = main